import { defineComponent as _defineComponent } from 'vue'
import BCXQuickLayer from '@/components/molecules/BCXQuickLayer.vue';
import BCXPanel from '@/components/molecules/BCXPanel.vue';
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';
import { computed, ref } from 'vue';
import BCXRadio from '@/components/molecules/forms/BCXRadio.vue';
import { watchImmediate } from '@vueuse/core';
import useI18n from '@/mixins/useI18n';
import ProjectForumService from '@/services/ProjectForumService';
import { Project } from '@/views/project-forum/models/ProjectForum';

type Item = {
  value: 'close' | 'close-decline' | 'open';
  label: string;
  disabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectStatusLayer',
  emits: ['update:is-open'],
  setup(__props, { emit }) {

const { t } = useI18n();
const { statusLayerProject, loadProjectsWithOffers } = useMyProjects();

const isOpen = computed(() => statusLayerProject.value?.status === 'ACTIVE');

const selection = computed(() => {
  const items: Item[] = [
    {
      value: 'close',
      label: `${t('my-projects.offers-detail.status-popup.actions.close')}`,
      disabled: !isOpen.value
    },
    {
      value: 'close-decline',
      label: `${t('my-projects.offers-detail.status-popup.actions.close-decline')}`,
      disabled: !isOpen.value
    },
    {
      value: 'open',
      label: `${t('my-projects.offers-detail.status-popup.actions.open')}`,
      disabled: isOpen.value
    }
  ];
  return items;
});



const selectedItem = ref<Item['value']>('close');

watchImmediate(isOpen, (is) => {
  selectedItem.value = is ? 'close' : 'open';
});

const updateProject = async (newStatus: Project['status'], autoRejectAllOffers = false) => {
  const project = statusLayerProject.value;
  if (!project) return;

  await ProjectForumService.updateProject(
    project.id, {
      ...project,
      status: newStatus,
      autoRejectAllOffers
    }
  );
};

const changeStatus = async () => {
  if (selectedItem.value === 'open') await updateProject('ACTIVE');
  else if (selectedItem.value === 'close') await updateProject('CLOSED');
  else if (selectedItem.value === 'close-decline') await updateProject('CLOSED', true);

  await loadProjectsWithOffers({
    invalidateAll: true
  });

  emit('update:is-open', false);
};


return { __sfc: true,t, statusLayerProject, loadProjectsWithOffers, isOpen, selection, emit, selectedItem, updateProject, changeStatus, BCXQuickLayer, BCXPanel, BCXRadio }
}

})